import React from 'react';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import styles from './FleetSalesImageCarouselCard.module.scss';
import { useMediaQuery } from 'usehooks-ts';

const FleetSalesImageCarouselCard = ({ url, alt }) => {
  const isMobile = useMediaQuery('(max-width: 480px)');
  return (
    <div className={styles.card}>
      {isMobile ? (
        <img
          src={url?.mobileImage?.value.src}
          alt={url?.mobileImage?.value.alt}
          width={url?.mobileImage?.value.width}
          height={url?.mobileImage?.value.height}
        />
      ) : (
        <img
          src={url?.desktopImage?.value?.src}
          alt={url?.desktopImage?.value?.alt}
          width={url?.desktopImage?.value?.width}
          height={url?.desktopImage?.value?.height}
        />
      )}
    </div>
  );
};

export default FleetSalesImageCarouselCard;
